export const ADMIN = "ADMIN";
export const APPNAME = "CMS";

//#region ImageType
export const UPLOADIMAGES = "UploadImages";
export const UploadDocuments = "UploadDocuments";
export const PackageImageType = "Package";
export const SpecialityToursImageType = "SpecialityTours";
export const HomeSliderImageType = "HomeSlider";
export const DestinationHotImageType = "DestinationHot";
export const BestTourPackagesImageType = "BestTourPackages";
export const CityImageType = "City";
export const ContactUsImageType = "ContactUs";
export const ArticlesImageType = "Articles";
export const BlogImageType = "Blog";
export const VisaDocumentsImageType = "VisaDocuments";
export const VisaAssistanceImageType = "VisaAssistance";
export const HealthandMedicalImageType = "HealthandMedical";
export const FirstTravellerImageType = "FirstTraveller";
export const UserFeedbackImageType = "UserFeedback";
export const CityAirportMasterImageType = "CityAirportMaster";
export const AgentDetailsImageType = "AgentDetails";
export const MemberImageType = "Member";
export const WhatWeDoImageType = "WhatWeDo";
export const GroupsAndWeddingsImageType = "GroupsAndWeddings";
export const NewsRoomImageType = "NewsRoom";
export const ManageHeadingImageType = "ManageHeading";
export const WhyChooseImageType = "WhyChoose";
export const SEOContentImageType = "SEOContent";
export const CampaignAttachmentType = "Campaign";
//#endregion
export const NextYearsDDL = 5;
export const cultureFormat = "en-IN";

//#region ModulePermission
export const ModulePermissionDashboard = "dashboard";
export const ModulePermissionTrafficDashboard = "trafficdashboard";

//#region User Manager
export const ModulePermissionUsers = "users";
export const ModulePermissionModuleRolePermission = "modulepermission";
export const ModulePermissionUserRoleMapping = "rolemapping";
//#endregion

//#region Package Master
export const ModulePermissionRegion = "region";
export const ModulePermissionCountry = "country";
export const ModulePermissionState = "state";
export const ModulePermissionCity = "city";
export const ModulePermissionCityInfo = "cityinfo";
export const ModulePermissionCityAirport = "cityairport";
export const ModulePermissionSpecialityTour = "specialitytour";
export const ModulePermissionPackageCategory = "packagecategory";
export const ModulePermissionTourCategory = "tourcategory";
export const ModulePermissionDiscount = "discount";
export const ModulePermissionPhoto = "photo";
export const ModulePermissionVideo = "video";
export const ModulePermissionHeaderMegaMenu = "headermegamenu";
//#endregion

//#region Manage Supplier
export const ModulePermissionSupplierPay = "supplierpay";
export const ModulePermissionSuppliers = "suppliers";
//#endregion

//#region Packages
export const ModulePermissionCustomizedPackages = "customizedpackages";
export const ModulePermissionFixedPackages = "fixedpackages";
export const ModulePermissionCustomizedHomeSlider = "customizedhomeslider";
export const ModulePermissionCustomizedDestinationHot = "customizeddestinationhot";
export const ModulePermissionCustomizedBestTourPackages = "besttourpackages";
export const ModulePermissionCustomizedHomeBlogOthers = "homeblogothers";
export const ModulePermissionTrendingPackage = "trendingpackage";
//#endregion

//#region WebSite Content
export const ModulePermissionAboutUs = "aboutus";
export const ModulePermissionContactUs = "contactus";
export const ModulePermissionWhyUs = "whyus";
export const ModulePermissionArticle = "article";
export const ModulePermissionBlog = "blog";
export const ModulePermissionReview = "review";
export const ModulePermissionTestimonial = "testimonial";
export const ModulePermissionCareer = "career";
export const ModulePermissionFAQ = "faq";
export const ModulePermissionVisaDocuments = "visadocuments";
export const ModulePermissionVisaAssistance = "visaassistance";
export const ModulePermissionHealthandMedical = "healthandmedical";
export const ModulePermissionFirstTraveller = "firsttraveller";
export const ModulePermissionManageHeading = "manageheading";
export const ModulePermissionMember = "member";
export const ModulePermissionWhatWeDo = "whatwedo";
export const ModulePermissionGroupsAndWeddings = "groupsandweddings";
export const ModulePermissionNewsRoom = "newsroom";
export const ModulePermissionWhyChoose = "whychoose";
export const ModulePermissionTermsCondition = "termscondition";
export const ModulePermissionPRCPolicy = "prcpolicy";
//#endregion


//#region Enquiry
export const ModulePermissionEnquiryNow = "enquirynow";
export const ModulePermissionEnquiryList = "enquirylist";
export const ModulePermissionCanceEnquiryList = "cancelenquirylist";
//#endregion

//#region Quotation
export const ModulePermissionProforma = "proforma";
export const ModulePermissionAgent = "agent";
//#endregion

//#region External Guest
export const ModulePermissionExternalGuest = "externalguest";
//#endregion

//#region External Guest
export const ModulePermissionSEO = "seo";
export const ModulePermissionCompanyDetails = "companydetails";
//#endregion

//#region Campaign
export const ModulePermissionCampaignlist = "campaignlist";
export const ModulePermissionCampaignBuilder = "campaignbuilder";
export const ModulePermissionContactList = "contactlist";
export const ModulePermissionAddNewContact = "addnewcontact";
export const ModulePermissionContactGroup = "contactgroup";
//#endregion

//#region TMS
export const ModulePermissionBranch = "branch";
export const ModulePermissionDepartment = "department";
//#endregion

//#endregion